import { render, staticRenderFns } from "./otd-terms.vue?vue&type=template&id=9d305c1a"
import script from "./otd-terms.vue?vue&type=script&lang=ts"
export * from "./otd-terms.vue?vue&type=script&lang=ts"
import style0 from "./otd-terms.vue?vue&type=style&index=0&id=9d305c1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports